import React, { Component } from 'react'

import { TweenMax, Power2, CSSPlugin, AttrPlugin } from 'gsap/all'
import FontObserver from 'font-face-observer'
import debounce from 'lodash/debounce'
import E from 'utils/emitter'

import Hero from 'components/sections/Hero'
import Footer from 'components/sections/Footer'

import styles from './styles.module.scss'

const plugins = [CSSPlugin, AttrPlugin]

class App extends Component {
  constructor(props) {
    super(props)

    this.state = {
      projects: [],
      loaded: false,
    }

    this.onResize = debounce(this.onResize, 400)
  }

  componentWillMount() {
    window.addEventListener('resize', this.onResize)
    this.checkFonts()
  }

  componentDidMount() {
    E.emit('appDidMount')
    this.showPage()
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize)
  }

  onResize = () => {
    E.emit('resize')
  }

  checkFonts = () => {
    const fonts = [
      {
        family: 'Dharma',
        weight: 'normal',
      },
      {
        family: 'Helvetica Neue',
        weight: 'normal',
      },
      {
        family: 'Helvetica Neue',
        weight: 'bold',
      },
    ]

    const observers = fonts.map((font) =>
      new FontObserver(font.family, {
        weight: font.weight,
      }).check()
    )

    Promise.all(observers)
      .then(() => {
        console.log('All fonts loaded')
        E.emit('resize')
      })
      .catch(() => {
        console.log('Some fonts might be missing...')
      })
  }

  showPage = () => {
    TweenMax.to(this.page, 1, {
      autoAlpha: 1,
      delay: 0.8,
      ease: Power2.easeNone,
    })
  }

  render() {
    return (
      <div ref={(el) => (this.page = el)} className={styles.wrapper}>
        <Hero />
        <Footer />
      </div>
    )
  }
}

export default App
